import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {gettext, interpolate} from 'utils/text';
import getCurrency from 'utils/getCurrency';
import reverseUrl from 'utils/urls';

import EmptyCart from './EmptyCart';
import {fetchCart, removeItem} from '../../ducks/basket';
import {BasketPropType, LinesPropType} from '../../utils/propTypes';

const FREE_SHIPPING_THRESHOLD = 150;  // euros

class DropdownCart extends React.Component {
    static propTypes = {
        basket: BasketPropType.isRequired,
        lines: LinesPropType.isRequired,
        isLoading: PropTypes.bool.isRequired,

        onLoad: PropTypes.func.isRequired,
        onRemoveLine: PropTypes.func.isRequired,
    };

    static defaultProps = {
        basket: {},
        lines: [],
    };

    componentDidMount() {
        this.props.onLoad();
    }

    removeLine = (line) => {
        this.props.onRemoveLine(line);
    };

    renderLine = (line) => {
        const productUrl = reverseUrl('catalogue:detail', line.product.slug, line.product.id);

        const imageThumbnail = line.product.images.length > 0 ?
                                    line.product.images[0].original :
                                        DJ_CONST.defaultProductImage;

        return (
            <li key={line.product.id}>
                <div className="row">
                    <div className="col-sm-2">
                        <div className="image_container">
                            <a href={productUrl}>
                                <img src={imageThumbnail} alt={line.product.title} />
                            </a>
                        </div>
                    </div>
                    <div className="col-sm-9 pl-0">
                        <a className="image_container__product" href={productUrl}>
                            {line.product.title}
                        </a>
                        <p className="image_container__quantity">
                            {line.quantity} x {line.product.price.excl_tax.toFixed(2)}
                            {getCurrency(line.price_currency)}
                        </p>
                    </div>
                    <div className="col-sm-1">
                        <button onClick={() => this.removeLine(line)} className="basket-mini-item__remove">
                            <i className="icon icon--close" />
                        </button>
                    </div>
                </div>
            </li>
        );
    };

    renderLineList = () => (
        <ul className="basket-mini-item list-unstyled">
            {this.props.lines.map(line => this.renderLine(line))}
        </ul>
    );

    renderCartActions = () => {
        const basket = this.props.basket;
        const currency = getCurrency(basket.currency);

        const total = basket.total_excl_tax;
        const remaining = (FREE_SHIPPING_THRESHOLD - total).toFixed(2) + currency;
        const remainingStr = gettext("Add %s worth of products to your basket to earn free shipping");

        const isShippingFree = total >= FREE_SHIPPING_THRESHOLD;
        const shippingText = isShippingFree ?
            gettext("Shipping is free for this order.") :
            interpolate(remainingStr, [remaining]);

        const calcCartSum = basket.is_tax_known
            ? parseFloat(basket.total_incl_tax) + (isShippingFree ? 0 : parseFloat(basket.shipping_price.incl_tax))
            : parseFloat(basket.total_excl_tax) + (isShippingFree ? 0 : parseFloat(basket.shipping_price.excl_tax));

        return (
            <ul className="basket-mini-item list-unstyled">
                <li className="cart-actions">
                    <div className="row">
                        <div className="col-xs-4">
                            <div>
                                <p className="cart-actions__total">{gettext('Basket')}</p>
                                <h3 className="cart-actions__sum pull-right">
                                    {basket.total_excl_tax + currency}
                                </h3>
                            </div>
                            <div>
                                <p className="cart-actions__total">{gettext('Total')}</p>
                                <h3 className="cart-actions__sum pull-right">
                                    {calcCartSum.toFixed(2) + currency}
                                </h3>
                            </div>
                        </div>
                        <div className="col-xs-8 cart-actions__buttons text-right pt-1">
                            <a href={reverseUrl('basket:summary')} className="btn btn-alternative">
                                {gettext('View basket')}
                            </a>
                            <a href={reverseUrl('checkout:index')} className="btn btn-default">
                                {gettext('Checkout')}
                            </a>
                        </div>
                    </div>
                </li>
                <li className="cart-transportation">
                    <div className="row">
                        <div className="col-xs-12">
                            <i className="icon icon--truck" />
                            <span className="ml-2">
                                {shippingText}
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        );
    };

    renderCart() {
        return (
            <div>
                {this.renderLineList()}
                {this.renderCartActions()}
            </div>
        );
    }

    renderEmptyCart = () => (
        <ul className="basket-mini-item cart--empty list-unstyled">
            <li>
                <EmptyCart />
            </li>
        </ul>
    );

    render() {
        const {isLoading, lines} = this.props;

        if (isLoading) {
            return null;
        }

        return (
            <div>
                {lines.length ? this.renderCart() : this.renderEmptyCart()}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isLoading: state.basket.isLoading,
    basket: state.basket.details,
    lines: state.basket.lines,
});

const mapDispatchToProps = dispatch => ({
    onLoad: () => dispatch(fetchCart()),
    onRemoveLine: line => dispatch(removeItem(line)),
});

const DropdownCartConnector = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DropdownCart);

export default DropdownCartConnector;



// WEBPACK FOOTER //
// ./src/components/cart/DropdownCart.js